import { makeContext } from '../../utils'

export const { Provider: SurveyProviderProvider, useContext: useSurveyProvider } = makeContext(
  false,
  'SurveyProviderContext'
)
